<template>
  <div
    id="app"
    class="app"
    :class="{
      'full-web': !isIntegration,
    }"
    :style="getBgImage"
  >
    <Modal
      v-if="showFreeBetModal"
      ref="modal"
      class="free-bet-modal"
      :class="[{ mobile: isMobile }, { desktop: isDesktop }]"
      width="344px"
      height="348px"
      show-footer
      @close-modal="claimFreeBets()"
      @close-modal-outside="claimFreeBets('outside')"
    >
      <template #body>
        <img src="./assets/free-bet-star.png" alt="" />
        <div class="body-message-box">
          <div class="pre-title">{{ translations.general_free_bet_pre_title.toUpperCase() }}</div>
          <div class="title">{{ translations.general_free_bet }}</div>
          <div class="subtitle">{{ translations.general_congratulation.toUpperCase() }}</div>
          <span class="subtitle-2">{{ translations.general_claim_ticket }}</span>
        </div>
        <div class="action">
          <button class="button" @click="claimFreeBets">
            {{ claimFreeBetsLabel }}
          </button>
        </div>
      </template>
    </Modal>
    <Modal
      v-if="showFreeBetExpiredModal"
      ref="modal"
      class="free-bet-expired-modal"
      :class="[{ mobile: isMobile }, { desktop: isDesktop }]"
      html-id="free-bet-expired-confirm-modal"
      width="344px"
      height="348px"
      show-footer
      @close-modal="toggleFreeBetExpiredModal(false)"
      @close-modal-outside="toggleFreeBetExpiredModal('outside')"
    >
      <template #header>
        {{ translations.general_info }}
      </template>
      <template #body>
        {{ freeBetExpiredMessage }}
      </template>
      <template #footer>
        <button class="button" @click="toggleFreeBetExpiredModal(false)">
          {{ translations.general_ok }}
        </button>
      </template>
    </Modal>
    <router-view></router-view>
    <LandscapeNotification />
  </div>
</template>

<script>
import { webViewIntegration, integrator } from './utility';
import { isArray, startCase, has, merge, isNil } from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import betHandler from '../src/utility/betHandler';
import { getBallPositions, getNextBallId } from './utility/Bet';
import applyPalette from '@nsftx/games-sdk-js/src/utility/applyPalette';
import gtag from '@nsftx/games-sdk-js/src/utility/gtag';
import eventBus from '@nsftx/games-sdk-js/src/utility/eventBus';
import LandscapeNotification from '@nsftx/games-sdk-js/src/components/LandscapeNotification';
import { BusService } from '@nsftx/games-bus';
import Modal from '@nsftx/games-sdk-js/src/components/Modal';
import NoSleep from 'nosleep.js';
import { ulid } from 'ulid';

export default {
  name: 'App',
  components: {
    Modal,
    LandscapeNotification,
  },
  data() {
    return {
      isLoggedIn: false,
      check: null,
      checkTimeout: 10000,
      ticketCanceled: false,
      canceledTicket: {},
      initialChannels: [],
      subChannels: {},
      userFreeBets: {
        count: 0,
        betStake: 0,
      },
      payinTimoutWithoutTicketCheck: null,
    };
  },
  computed: {
    ...mapState([
      'config',
      'balls',
      'drawnBalls',
      'odds',
      'payinDisabledFromSocket',
      'colorsDrawn',
      'isBettingDisabled',
      'lastSelectedBet',
      'showFreeBetModal',
      'showFreeBetExpiredModal',
      'nextgenStandaloneIntegration',
      'bettingTabs',
    ]),
    ...mapGetters(['translations', 'isIsonis', 'isMobile', 'isDesktop', 'isTablet', 'isNextGen', 'customDomain']),
    ...mapGetters('gamesBetslip', ['ticket', 'totalPayment', 'selectedBet']),
    ...mapGetters('user', ['freeBets', 'user']),
    isMob() {
      return this.isMobile || window.innerWidth <= 660;
    },
    userProfile() {
      return this.user;
    },
    getBgImage() {
      if (this.isMob) {
        return { backgroundColor: 'var(--background-1)' };
      }
      return this.config.ui.dark ? this.bgImage : this.bgImageLight;
    },
    bgImage() {
      return {
        // eslint-disable-next-line import/extensions
        backgroundImage: `url(${require('@/assets/image.jpg')})`,
      };
    },
    bgImageLight() {
      return {
        // eslint-disable-next-line import/extensions
        backgroundImage: `url(${require('@/assets/image-light.jpg')})`,
      };
    },
    isStandAlone() {
      return this.config.ui.config.mode === 'standalone';
    },
    isGravityGateway() {
      return this.config.messageProtocol.name === 'gravityGateway';
    },
    isIntegration() {
      if (
        this.config.ui.config.mode &&
        (this.config.ui.config.mode === 'integration' || this.config.ui.config.mode === 'standalone')
      ) {
        return true;
      }
      return false;
    },
    isAndroidPlatform() {
      return webViewIntegration.isActive() && has(window, 'WebAppListener');
    },
    claimFreeBetsLabel() {
      if (this.isMobile) {
        return this.translations.general_claim;
      }
      return this.translations.general_ok;
    },
    freeBetExpiredMessage() {
      return this.translations.general_free_bet_expired_message;
    },
    isSevenPlatform() {
      return this.config.platformName === 'seven';
    },
    userLogged() {
      return this.userProfile.profile.logged || this.isLoggedIn;
    },
  },
  watch: {
    isLoggedIn() {
      eventBus.$emit('InitBoost');
    },
    odds(val) {
      if (this.selectedBet) {
        const newBet = JSON.parse(JSON.stringify(this.lastSelectedBet));
        newBet.betTab = this.lastSelectedBet.betTab;
        if (this.selectedBet.type === 'special') {
          //  newBet.odds = val[this.selectedBet.oddIndex][this.selectedBet.oddPosition];
          newBet.odd = val[this.selectedBet.oddIndex][this.selectedBet.oddPosition];
          setTimeout(() => {
            this.setLastSelectedBet(newBet);
            betHandler.addToBetslip(newBet);
            //  this.updateSelectedBet(newBet);
          }, 0);
        } else {
          //  newBet.odds = val[this.selectedBet.betType];
          newBet.odd = val[this.selectedBet.betType];
          setTimeout(() => {
            this.setLastSelectedBet(newBet);
            betHandler.addToBetslip(newBet);
            //  this.updateSelectedBet(newBet);
          }, 0);
        }
      }
    },
    colorsDrawn: {
      handler(val) {
        if (this.selectedBet && this.selectedBet.oddIndex === 9) {
          for (let i = 0; i < 6; i++) {
            if (val[i] === 8 && this.selectedBet.oddPosition === i + 1) {
              this.clearBetslip();
              eventBus.$emit('ClearSpecialBets');
              break;
            }
          }
        }
      },
      deep: true,
    },
    drawnBalls: {
      handler(val) {
        if (this.selectedBet) {
          const drawnBall = val[val.length - 1];
          if (this.selectedBet.numbers.includes(drawnBall)) {
            this.resetBalls();
            this.setLastSelectedBet(false);
            //  this.clearBetslip();
            (async () => {
              await this.clearBetslip();
            })();
          }
        }
        if (val.length === 35) {
          eventBus.$emit('ClearSpecialBets');
          this.clearBetslip();
        }
        if (val.length % 2 === 0) {
          this.setHideLoader(true);
          if (this.userLogged) {
            setTimeout(() => {
              this.getLastTickets();
              if (this.isStandAlone && !this.isGravityGateway) {
                this.getUserBalance();
              }
            }, 300);
            setTimeout(async () => {
              if (this.nextgenStandaloneIntegration) {
                await window.igniteInstance.getWallets().then((result) => {
                  if (result.activeCurrencyBalance) {
                    this.setUserBalance(result.activeCurrencyBalance);
                  }
                });
              }
            }, 1000);
          }
          setTimeout(() => {
            this.setHideLoader(false);
          }, 1200);
        }
      },
      deep: true,
    },
    payinDisabledFromSocket(val) {
      if (this.selectedBet && !val) {
        setTimeout(() => {
          if (this.lastSelectedBet !== false) {
            this.setIsPayinButtonDisabled(false);
          }
        }, 1200);
      }
      if (val === true) {
        this.setIsPayinButtonDisabled(true);
      }
    },
    selectedBet: {
      handler(val) {
        if (val && this.lastSelectedBet && !this.payinDisabledFromSocket) {
          this.setIsPayinButtonDisabled(false);
        }
      },
      deep: true,
    },
    userLogged(value) {
      if (value) {
        this.getLastTickets();
      }
    },
  },
  beforeMount() {
    this.busService = new BusService({
      environment: this.config.environment,
      platform: this.config.platformName,
      productName: this.config.productName,
      productId: this.config.productId,
      tenantId: this.config.tenantId,
      locale: this.config.locale,
      applicationName: this.config.applicationName,
      useCommonEventName: true,
      adapters: [{ name: 'GcmAdapter' }],
      clientMessageProtocol: this.config.messageProtocol,
      subChannels: this.subChannels,
      initialChannels: this.initialChannels,
      customDomain: this.customDomain,
    });
    this.busService.start();
    if (this.isMobile || this.isTablet) {
      this.addBettingTab({
        componentName: 'specials',
        text: 'general_active_tickets',
        active: false,
        disabled: false,
      });
    }

    (async () => {
      if (this.isNextGen && this.userProfile?.profile?.id) {
        this.busService.addChannel('Player', this.userProfile.profile.id);
      }
    })();

    this.getStats();
    this.getResults();
  },
  mounted() {
    if (this.isMobile) {
      const noSleep = new NoSleep();
      let wakeLockEnabled = false;
      document.addEventListener(
        'click',
        function enableNoSleep() {
          document.removeEventListener('click', enableNoSleep, false);
          if (!wakeLockEnabled) {
            noSleep.enable();
            wakeLockEnabled = true;
          } else {
            noSleep.disable();
            wakeLockEnabled = false;
          }
        },
        false,
      );
    }
    this.load();
    const device = this.isMobile ? 'mobile' : this.isTablet ? 'tablet' : 'desktop';
    this.setupGtag(device);
    this.setMaxBallsInNextSix(this.config.bets);
    this.setMaxBallsNextBall(this.config.bets);
    this.setTheme(this.config);
    this.setPageTitle();
    window.addEventListener('Bus:Message', (event) => {
      const { data, eventName, balls, odds, eventId, ball, id } = event.detail;
      switch (eventName) {
        case 'SetState':
          this.handleSetState(balls, odds, eventId);
          break;
        case 'PayinDisable':
          this.setPayinDisabledFromSocket(true);
          break;
        case 'DrawResult':
          this.handleDrawResults(id, ball, eventId);
          break;
        case 'SetResults':
          this.handleSetResults();
          break;
        case 'StartEvent':
          //  this.disableAllBetting(false);
          this.getStats();
          this.getResults();
          if (this.isStandAlone && !this.isGravityGateway) {
            this.getUserBalance();
          }
          break;
        case 'odds':
          setTimeout(() => {
            this.setPayinDisabledFromSocket(false);
          }, 1100);
          if (this.selectedBet) {
            setTimeout(() => {
              this.setIsPayinButtonDisabled(false);
            }, 2400);
          }
          setTimeout(() => {
            this.setOdds(event.detail.odds);
            this.disableAllBetting(false);
          }, 1200);
          break;
        case 'User.AuthorizationChanged':
          this.handleAuthorizationChanged(data);
          break;
        case 'User.ProfileChanged':
          this.setUserBalance(event.detail.data.auth.user.balance);
          break;
        case 'User.SettingsChanged':
          if (!this.isLoggedIn) {
            this.resetUserFreeBets();
            this.clearBetslip();
            this.setUserFreeBets(this.userFreeBets);
          } else {
            this.getUserFreeBets();
          }
          break;
        case 'User.BalanceChanged':
          this.setUserBalance(event.detail.data.balance);
          break;
        case 'TicketUpdate': {
          this.handleTicketUpdate(event.detail);
          break;
        }
        // IGNITE
        case 'onSettingsUpdated':
          if (this.config.locale !== event.detail.data.activeLocale) {
            this.updateConfig({ locale: event.detail.data.activeLocale });
            // TODO HANDLE TRANSLATIONS CHANGE
          }
          if (this.config.currency !== event.detail.data.activeCurrencyBalance) {
            this.updateConfig({ currency: event.detail.data.activeCurrency.code });
          }
          break;
        case 'onBettingDenied': // TODO
          this.disableAllBetting(true);
          this.setPernamentBettingDisabled(true);
          this.setIsPayinButtonDisabled(true);
          break;
        case 'onBettingAllowed': // TODO
          this.setPernamentBettingDisabled(false);
          this.disableAllBetting(false);
          this.setIsPayinButtonDisabled(false);
          break;
        case 'onCancelBetsRequested':
          console.log('CANCEL BETS REQUESTED:', event.detail.data);
          console.warn('Cancel not possible on this game');
          break;
        case 'onReBetRequested':
          console.log('REBET REQUESTED:', event.detail.data);
          console.warn('Rebet not possible on this game');
          break;
        case 'FreeBet':
          this.userFreeBets = event.detail;
          // eslint-disable-next-line no-case-declarations
          const { subtype } = event.detail;
          if (subtype === 'new') {
            this.toggleFreeBetModal(true);
          } else {
            if (this.userProfile.freeBets.count > 0) {
              this.toggleFreeBetExpiredModal(true);
            }
            this.getUserFreeBets();
          }
          break;
        case 'balanceUpdate': {
          const balanceList = event.detail.balanceArray;
          if (balanceList.length && !isNil(balanceList[0].balanceAmt)) {
            this.setUserBalance(balanceList[0].balanceAmt);
          }
          this.clearCheckTimeout(this.check);
          this.clearCheckTimeout(this.payinTimoutWithoutTicketCheck);
          break;
        }
        default:
          break;
      }
    });

    eventBus.$on('ReturnToLobby', this.handleReturnToLobby);
    eventBus.$on('PayinDone', this.resetBalls);
    eventBus.$on('TicketPayin', this.handleTicketPayin);
    eventBus.$on('igniteTicketCancelled', this.handleIgniteTicketCancelled);
    eventBus.$on('LoadLastTickets', this.getLastTickets);
    eventBus.$on('PrebetCleared', () => {
      this.setLastSelectedBet(false);
      this.resetBalls();
    });
    eventBus.$on('LoginRequired', () => {
      if (window.WebAppListener) {
        window.WebAppListener.sendMessage('User.LoginRequired');
      }
      this.busService.sendMessage(
        {
          action: 'User.LoginRequired',
        },
        true,
      );
      integrator.sendMessage({
        type: 'loginRequired',
      });
    });

    if (this.config.platformConfig.clientType === 'token') {
      if (this.userProfile && this.userProfile?.profile?.id) {
        this.togglePlayerChannel(this.userProfile.profile.id);
        this.getLastTickets();
      }
    }
    if (this.config.platformName !== 'seven' && this.config.platformName !== 'NextGen') {
      this.thirdPartyPlatformSubscribe();
    }
  },
  methods: {
    ...mapActions([
      'getStats',
      'getResults',
      'setUserBalance',
      'setActiveBettingTab',
      'resetColors',
      'resetBalls',
      'setDrawnColor',
      'updateRound',
      'addBettingTab',
      'disableAllBetting',
      'setCanceledTicket',
      'setPayinDisabledFromSocket',
      'setLastSelectedBet',
      'setHideLoader',
      'setDrawnBallsStateActive',
      'setTicketPayinInProg',
      'updateConfig',
      'setPernamentBettingDisabled',
      'toggleFreeBetModal',
      'toggleFreeBetExpiredModal',
      'setLastDrawnBallId',
      'setOdds',
      'clearDrawnBalls',
      'addDrawnBall',
      'setLessThanSixBallsLeft',
      'resetRemainingBalls',
      'updateRemainingBalls',
      'setBettingTabProperties',
      'setBallProperties',
    ]),
    ...mapActions('user', ['setUserFreeBets', 'getUserFreeBets', 'getUserBalance', 'updateUser']),
    ...mapActions('gamesBetslip', [
      'setIsPayinButtonDisabled',
      'getLastTickets',
      'setIsPayinInProgress',
      'clearBetslip',
      'payIn',
      'ticketCheck',
    ]),
    ...mapActions('notifications', ['setNotification', 'clearNotification']),
    load() {
      if (this.isAndroidPlatform) {
        window.WebAppListener.sendMessage('Slave.Loaded');
      }
      this.busService.sendMessage({ action: 'Slave.Loaded' }, true);
    },
    setMaxBallsInNextSix(bets) {
      if (bets[7].value && bets[6].value && bets[5].value) {
        this.setInNextSixMaxBall(3);
      }
      if (!bets[7].value && bets[6].value && bets[5].value) {
        this.setInNextSixMaxBall(2);
      }
      if (!bets[7].value && !bets[6].value && bets[5].value) {
        this.setInNextSixMaxBall(1);
      }
    },
    setMaxBallsNextBall(bets) {
      if (bets[3].value && bets[0].value) {
        this.setNextBallMaxBall(2);
      }
      if (!bets[3].value && bets[0].value) {
        this.setNextBallMaxBall(1);
      }
    },
    clearCheckTimeout(timeout) {
      clearTimeout(timeout);
    },
    setInNextSixMaxBall(balls) {
      this.setBettingTabProperties({
        index: 0,
        maxBalls: balls,
      });
    },
    setNextBallMaxBall(balls) {
      this.setBettingTabProperties({
        index: 1,
        maxBalls: balls,
      });
    },
    checkTicket(requestUuid) {
      this.check = setTimeout(async () => {
        try {
          const response = await this.ticketCheck(requestUuid);
          if (response.data.status.value.toUpperCase() !== 'PENDING') {
            const msg = {
              message: this.translations.general_ticket_confirmed,
              status: 'positive',
              notificationTimeout: 3000,
            };
            this.clearAndSetNotification(msg);
            this.getLastTickets();
          }
        } catch (error) {
          const notification = {
            type: 'warning',
            message: error.message,
            notificationTimeout: 3000,
          };
          this.clearAndSetNotification(notification);
        }
        this.resetBalls();
        this.clearCheckTimeout(this.check);
        this.clearCheckTimeout(this.payinTimoutWithoutTicketCheck);
        this.setLastSelectedBet(false);
        this.setIsPayinInProgress(false);
        this.setTicketPayinInProg(false);
        eventBus.$emit('ClearSpecialBets');
        eventBus.$emit('PayinDone');
      }, this.checkTimeout);
    },
    setTheme(config) {
      const rootElement = document.documentElement;
      const baseColor = config.ui[config.ui.config.baseColor];
      const theme = config.ui[config.ui.config.theme];
      applyPalette.set(merge(theme, baseColor), rootElement);
    },
    authUser(auth) {
      this.updateUser({
        auth: {
          token: auth.token,
          tpToken: auth.tpToken,
        },
        profile: auth.user || auth,
      });
      this.isLoggedIn = !!auth?.user?.logged || auth.id || !!auth?.user?.id;
      if (this.isLoggedIn) {
        if (window.WebAppListener) {
          this.getUserFreeBets();
        }
        this.togglePlayerChannel(this.userProfile.profile.id);
      }
    },
    reset() {
      this.clearDrawnBalls();
      this.setLessThanSixBallsLeft(false);
      this.resetRemainingBalls();

      for (let j = 0; j < this.bettingTabs.length; j += 1) {
        this.setBettingTabProperties({
          index: j,
          active: j === 0,
          disabled: false,
        });
      }
      this.setActiveBettingTab(0);
      for (let i = 0; i < this.balls.length; i += 1) {
        if (this.balls[i].tabs) {
          this.setBallProperties({
            index: i,
            tabs: [],
          });
        }
        if (this.balls[i].style) {
          this.setBallProperties({
            index: i,
            style: {
              disabled: false,
              active: false,
            },
          });
        }
      }
      this.resetColors();
      this.setLastDrawnBallId(null);
    },
    drawnBallsCheck(balls) {
      if (balls?.length >= 30) {
        this.setLessThanSixBallsLeft(true);
      }
    },
    getPrintTemplate() {
      let template = '';
      const messages = this.translations;
      const { currency } = this.config;
      const bets = this.ticket.length ? this.ticket : [this.selectedBet];
      template += 'Next Six;';
      template += "{{ ticketDateTimeUTC | date('d.m.Y H:i:s', false) }};";
      template += `${messages.general_pay_in} {{ payin | number_format(2, '.', ',') }}${currency} `;
      template += `${messages.general_payout} {{ payout | number_format(2, '.', ',') }}${currency} `;

      return (
        template +
        bets
          .map((bet) => {
            const betOutcome = isArray(bet.outcome) ? bet.outcome.join(',') : bet.outcome;
            const betMarket = !bet.color ? `${bet.market} ${bet.category ? bet.category : ''}` : bet.category;
            let body = '';
            let round = '';

            for (let i = 0; i < bet.numEvents; i += 1) {
              round = `${messages.general_round} : {{bets[0].eventId + ${i}}}`;
              body += `${round} `;
              body += `${betOutcome} `;
              body += `${betMarket} `;
            }
            return body;
          })
          .join('; ') +
        '{{ id }}'
      );
    },
    getNumbers(bet) {
      if (bet.numbers.length === 0) {
        return bet.value;
      }
      if (bet.numbers.length === 1) {
        return bet.numbers[0];
      }
      return bet.numbers;
    },
    formatTicketBets() {
      const tickets = this.ticket.length ? this.ticket : [this.selectedBet];
      const ballId = getNextBallId();
      const result = tickets.map((n) => ({
        payin: n.payment || Number(this.totalPayment),
        market: 'Standard',
        type: n.betType,
        ballId,
        ballPositions: getBallPositions(n, ballId),
        value: this.getNumbers(n),
        numEvents: 1,
      }));
      return result;
    },
    togglePlayerChannel(playerId) {
      if (playerId) {
        this.busService.addChannel(`${this.config.productName}.Player`, playerId);
      } else {
        this.busService.removeChannel(`${this.config.productName}.Player`, this.userProfile.profile.id);
      }
    },
    setupGtag(device) {
      if (this.config.ui.config.gtm && this.config.ui.config.gtm[device]) {
        const { code, auth, preview } = this.config.ui.config.gtm[device];
        gtag.setup(code, auth, preview);
        return;
      }
      gtag.setup();
    },
    setPageTitle() {
      const { productFqn, applicationName } = this.config;
      document.title = `${startCase(productFqn)}: ${applicationName}`;
    },
    thirdPartyPlatformSubscribe() {
      if (this.config.user && this.config.user.id) {
        this.authUser(this.config.user);
        this.getLastTickets();
        this.setUserBalance(this.config.user.balance);
        this.busService.addChannel('DeliveryPlatform', this.config.platformConfig.clientPlatform);
        const params = new URLSearchParams(window.location.search);
        let queryParams = {};
        params.forEach((value, key) => {
          queryParams[key] = value;
        });
        if (queryParams.casino) {
          this.busService.addChannel('Balance', `${queryParams.casino}-${this.config.user.username}`);
        }
      }
    },
    claimFreeBets() {
      this.clearBetslip();
      this.setUserFreeBets(this.userFreeBets);
      this.toggleFreeBetModal(false);
    },
    resetUserFreeBets() {
      this.userFreeBets = {
        count: 0,
        betStake: 0,
      };
    },
    async clearAndSetNotification(notification) {
      await this.clearNotification();
      this.setNotification(notification);
    },
    handleSetState(balls, odds, eventId) {
      // Playtech integration has additional channel subsctiptions (player balance)
      // Game state message happens before player state message and this reset causes an issue
      // where the drawnBalls are overriden and set to 0 when they shouldn't be.
      if (balls && balls.length === 0) {
        this.reset();
      }

      if (this.isSevenPlatform || this.isNextGen) this.clearDrawnBalls();

      if (balls && this.drawnBalls.length === 0) {
        if (balls.length >= 30) {
          eventBus.$emit('SwitchToNextBallTab');
        }
        for (let i = 0; i < balls.length; i += 1) {
          this.addDrawnBall(balls[i].ball);
          this.setDrawnColor(balls[i].ball);
          this.updateRemainingBalls(balls[i].ball);
        }
      }
      this.setOdds(odds || {});
      this.updateRound(eventId);
      this.drawnBallsCheck(balls);
      if (this.balls.length > 2) {
        this.disableAllBetting(false);
      }
      if (this.drawnBalls.length >= 35) {
        this.setLastSelectedBet(false);
        this.clearBetslip();
        this.resetBalls();
        this.disableAllBetting(true);
        eventBus.$emit('ClearSpecialBets');
        this.reset();
      }

      if (this.userLogged) {
        this.getUserFreeBets();
      }
    },
    handleDrawResults(id, ball, eventId) {
      this.setLastDrawnBallId(id);
      this.setDrawnBallsStateActive(true);
      this.updateRound(eventId);
      this.setDrawnColor(ball);
      setTimeout(() => {
        this.setDrawnBallsStateActive(false);
      }, 1800);
      // eslint-disable-next-line no-case-declarations
      const ticket = this.ticket.length ? this.ticket : [this.selectedBet];
      if (ticket.length > 0 && ticket.type === 'numbers') {
        betHandler.addToBetslip({
          type: 'numbers',
          numbers: ticket.numbers,
          odd: ticket.odd,
          betTab: ticket.bettingTab,
        });
      }
      setTimeout(async () => {
        if (ticket.bets && ticket.bets[0]) {
          if (ticket.bets[0].isNumberOnBetslip(ball)) {
            await this.resetBalls();
          }
        }

        this.addDrawnBall(ball);
        this.updateRemainingBalls(ball);
        this.drawnBallsCheck(this.drawnBalls);

        if (this.isBettingDisabled) {
          if (this.drawnBalls.length >= 30) {
            eventBus.$emit('SwitchToNextBallTab');
          }
          this.disableAllBetting(false);
        }
      }, 1200);
    },
    handleSetResults() {
      this.disableAllBetting(true);
      eventBus.$emit('ClearSpecialBets');
      this.clearDrawnBalls();
      this.resetBalls();
      this.setLastSelectedBet(false);
      this.clearBetslip();
      this.reset();
    },
    handleAuthorizationChanged(data) {
      const authData = data.auth;
      if (authData) {
        const playerId = authData.user?.id || null;
        this.togglePlayerChannel(playerId);
        this.authUser(authData);
        this.setUserBalance(authData.user.balance);
      }
      if (this.isStandAlone && this.isGravityGateway) {
        this.getUserBalance();
      }
      if (!this.userLogged) {
        if (this.lastSelectedBet) {
          this.setLastSelectedBet(false);
          this.clearBetslip();
          this.resetBalls();
          eventBus.$emit('ClearSpecialBets');
        }
        eventBus.$emit('closeTicketHistory');
      } else {
        this.getUserFreeBets();
      }
      if (this.isNextGen) {
        this.updateUser({
          auth: data?.auth,
          profile: data?.auth?.user,
        });
      }
    },
    handleTicketUpdate(ticket) {
      const msg = {
        message: this.translations.general_ticket_confirmed,
        status: 'positive',
        notificationTimeout: 3000,
      };
      if (this.userLogged) {
        if (ticket.id && ticket.status.id === '0') {
          (async () => {
            await this.clearBetslip();
            this.clearAndSetNotification(msg);
            for (let i = 0; i < this.balls.length; i += 1) {
              this.setBallProperties({
                index: i,
                tabs: [],
              });
              if (this.balls[i].style) {
                this.setBallProperties({
                  index: i,
                  style: {
                    active: false,
                  },
                });
              }
            }
            this.resetBalls();
            // eslint-disable-next-line no-case-declarations
            const ticketsResolved = {
              action: 'Tickets.Resolved',
              data: {
                accepted: true,
                ticket: ticket,
              },
            };
            this.busService.sendMessage(ticketsResolved, true);
          })();
          setTimeout(() => {
            this.clearNotification();
          }, 1000);
          this.setLastSelectedBet(false);
          this.setIsPayinInProgress(false);
          this.setTicketPayinInProg(false);
          this.getUserFreeBets().then(() => {
            if (!this.freeBets.count) {
              this.clearBetslip();
            }
          });
          eventBus.$emit('ClearSpecialBets');
          eventBus.$emit('PayinDone');
        }
        if (ticket.id && ticket.status.id === '1') {
          msg.message = this.translations.general_ticket_canceled;
          msg.status = 'neutral';
          this.setCanceledTicket(ticket);
        }
        if (ticket.code) {
          msg.message = ticket.message;
          msg.status = 'negative';
          (async () => {
            await this.clearBetslip();
            this.clearAndSetNotification(msg);
          })();
          this.resetBalls();
          this.setIsPayinInProgress(false);
          this.setTicketPayinInProg(false);
          eventBus.$emit('ClearSpecialBets');
        }
        if (this.isStandAlone && !this.isGravityGateway) {
          this.getUserBalance();
        }
        this.disableAllBetting(false);
        this.getLastTickets();
        this.clearCheckTimeout(this.check);
        this.clearCheckTimeout(this.payinTimoutWithoutTicketCheck);
      }
    },
    handleReturnToLobby() {
      {
        this.busService.sendMessage(
          {
            action: 'UI.Show',
            data: {
              name: 'Lobby',
            },
          },
          true,
        );
        if (window.WebAppListener) {
          window.WebAppListener.sendMessage('Navigation.Back');
        }
      }
    },
    async handleTicketPayin() {
      //  this.setIsPayinButtonDisabled(true);
      this.setIsPayinInProgress(true);
      this.setTicketPayinInProg(true);
      if (this.isNextGen) {
        const message = {
          message: this.translations.general_ticket_resolving,
          status: 'neutral',
        };
        this.setNotification(message);
      }
      this.disableAllBetting(true);

      try {
        const response = await this.payIn({
          payload: this.formatTicketBets,
          additionalInfo: this.isIsonis
            ? {
                printTemplate: this.getPrintTemplate(),
                timezone: {
                  offset: parseInt(this.userProfile.profile.profile.timezoneOffset, 10),
                },
              }
            : null,
          providerBetslipId: ulid() || null,
        });

        if (this.isNextGen && response.status === 201) {
          this.setIsPayinInProgress(false);
          this.setTicketPayinInProg(false);
          this.disableAllBetting(false);
          this.resetBalls();
          eventBus.$emit('ClearSpecialBets');
          this.clearBetslip();
          const message = {
            message: this.translations.general_ticket_confirmed,
            status: 'positive',
            notificationTimeout: 3000,
          };
          this.clearAndSetNotification(message);
          this.getLastTickets();
          this.getUserFreeBets();
          if (this.nextgenStandaloneIntegration) {
            await window.igniteInstance.getWallets().then((result) => {
              if (result.activeCurrencyBalance) {
                this.setUserBalance(result.activeCurrencyBalance);
              }
            });
          }
        } else if (this.isSevenPlatform) {
          this.checkTicket(response.data.requestUuid);
          const message = {
            message: this.translations.general_ticket_resolving,
            status: 'neutral',
          };
          this.setNotification(message);
          this.setIsPayinInProgress(true);
          this.setTicketPayinInProg(true);
          this.disableAllBetting(true);
        } else {
          // If ticket update is missing and no ticket check api is available (playtech)
          // loader should be cleared and generic error message displayed
          this.payinTimoutWithoutTicketCheck = setTimeout(() => {
            const message = {
              message: this.translations.general_ticket_error,
              status: 'negative',
              notificationTimeout: 2,
            };
            this.setNotification(message);
            this.setIsPayinInProgress(false);
            this.bettingDisable(false);
            this.getLastTickets();
          }, this.checkTimeout);
        }
      } catch (error) {
        if (error.response) {
          const errorData = error.response.data;
          const message = {
            message: errorData.message,
            status: 'negative',
            notificationTimeout: 3000,
          };
          this.setNotification(message);
        }
        this.resetBalls();
        eventBus.$emit('ClearSpecialBets');
        await this.clearBetslip();
        this.setIsPayinInProgress(false);
        this.setTicketPayinInProg(false);
        this.disableAllBetting(false);
      }
    },
    async handleIgniteTicketCancelled(ticketId) {
      this.ticketCanceled = true;
      this.canceledTicket = { id: ticketId };
      this.getLastTickets();
      if (this.nextgenStandaloneIntegration) {
        await window.igniteInstance.getWallets().then((result) => {
          if (result.activeCurrencyBalance) {
            this.setUserBalance(result.activeCurrencyBalance);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
@use './assets/style/helpers/_modal.scss';

* {
  margin: 0;
  padding: 0;
  outline-style: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  scrollbar-width: none;
}
html,
body {
  background-color: var(--background-1);
  padding: 0;
  margin: 0;
  width: 100%;
  overflow: auto;
  scrollbar-width: none;
  box-sizing: border-box;
  font-family: Roboto;
  -webkit-tap-highlight-color: transparent;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.app {
  background-repeat: no-repeat;
  background-size: cover;
  float: left;
  width: 100%;
  overflow-y: scroll;

  &.full-web {
    height: 100vh;
  }

  .free-bet-expired-modal {
    .modal {
      height: 182px;
    }
  }

  .free-bet-modal,
  .free-bet-expired-modal {
    .modal {
      background-color: var(--card);

      .modal-header,
      .modal-body {
        color: var(--text-primary-1);
      }

      .modal-header {
        font-size: 16px;
      }

      .modal-body {
        font-size: 14px;
        .modal-actions {
          display: none;
        }
      }
      .modal-footer {
        padding-right: 43px;
        position: relative;
      }
      .button {
        background: transparent;
        border: 0;
        outline: 0;
        font-size: 14px;
        color: var(--secondary);
        text-transform: uppercase;
        cursor: pointer;
        font-family: 'Roboto', sans-serif;
        padding: 31px 0 27px 0;
      }
    }
  }
}
.free-bet-modal {
  .modal {
    max-height: 348px !important;
    .modal-header {
      display: none;
    }
    .modal-body {
      height: 348px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: 0 0;
      background-repeat: no-repeat;
      position: relative;
      text-align: center;
      img {
        position: absolute;
        top: -2%;
        left: 22px;
        max-width: 100%;
      }
      .body-message-box {
        position: absolute;
        width: 100%;
        top: 66%;
        left: 50%;
        transform: translate(-50%, -50%);

        .title {
          font-size: 42px;
          font-weight: 700;
          color: #90b653;
          margin-bottom: 25px;
          text-transform: uppercase;
        }
        .subtitle {
          font-size: 18px;
          font-weight: 700;
        }
        .subtitle-2 {
          font-size: 14px;
          color: var(--text-primary-3);
        }
      }
    }
    .modal-footer {
      display: none;
    }
  }
  &.desktop {
    .modal {
      .modal-body {
        background-image: none;
        img {
          height: 60%;
          left: 50%;
          top: -2%;
          transform: translate(-50%, 0);
        }
        .body-message-box {
          top: 60%;
          .title {
            margin-bottom: 10px;
          }
          .pre-title {
            display: none;
          }
        }
        .action {
          position: absolute;
          bottom: 0;
          right: 16px;
        }
      }
    }
  }
  &.mobile {
    .modal {
      height: 70% !important;
      .modal-body {
        height: 100% !important;
        background-image: url('assets/free-bet-bg.svg');
        .action {
          position: absolute;
          left: 0;
          bottom: 20px;
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          .button {
            min-width: 150px;
            background: #90b653;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 30px;
            padding: 0;
            color: var(--text-secondary-1);
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
